import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from 'grab-ui';
import _get from 'lodash/get';
import pressedCursor from 'public/images/pressed-cursor.png';
import { creatingDeliveriesSelector } from 'selectors/new-booking-selectors';
import useCreatingDeliveriesResult from 'components/v2/anytime-booking/common/use-creating-deliveries-result';
import NewBookingDuck from 'ducks/new-booking-duck';
import NewBulkUploadDuck from 'ducks/new-bulk-upload-duck';
import notifyCreateDeliveriesResult from 'components/v2/anytime-booking/common/notify-create-deliveries-result';
import styles from './price-section.less';

const BookDeliveriesButton = ({
  disabled,
  buttonText,
  deliveryIDs,
  asyncValidationFunc,
  bookingMode,
  dispatch,
  creatingDeliveries,
  beforeFn,
}) => {
  const history = useHistory();
  const [preventDuplicate, setPreventDuplicate] = useState(false);
  const onCreateDeliveries = useCallback(
    (createDeliveryIDs, skipDuplicateBookingCheckDeliveryIDs) => {
      // prevent double clicking
      setPreventDuplicate(true);
      setTimeout(() => {
        setPreventDuplicate(false);
      }, 3000);

      (asyncValidationFunc ? asyncValidationFunc() : Promise.resolve())
        .then(() => {
          if (beforeFn) {
            beforeFn();
          }
          dispatch(
            NewBookingDuck.creators.createDeliveries({
              deliveryIDs: createDeliveryIDs,
              bookingMode,
              skipDuplicateBookingCheckDeliveryIDs,
            }),
          );
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log('async validation error', err);
        });
    },
    [dispatch, setPreventDuplicate, bookingMode, asyncValidationFunc, beforeFn],
  );

  const createDeliveriesCallback = useCallback(
    ({ successfulDeliveryIDs, failedDeliveryIDs, error, deliveryErrors }) => {
      notifyCreateDeliveriesResult(
        dispatch,
        successfulDeliveryIDs,
        failedDeliveryIDs,
        error,
        deliveryErrors,
        onCreateDeliveries,
      );
      dispatch(
        NewBulkUploadDuck.creators.removeSuccessfulDeliveries(
          successfulDeliveryIDs,
        ),
      );

      if (_get(failedDeliveryIDs, 'length', 0) <= 0) {
        history.push('/bookings');
      }
    },
    [dispatch, history, onCreateDeliveries],
  );

  useCreatingDeliveriesResult(createDeliveriesCallback);

  return (
    <Button
      type={'primary'}
      className={cx(styles.bookButton, {
        [styles.creating]: creatingDeliveries || preventDuplicate,
      })}
      disabled={disabled || preventDuplicate || creatingDeliveries}
      onClick={() => onCreateDeliveries(deliveryIDs, undefined)}
    >
      {(creatingDeliveries || preventDuplicate) && (
        <img className={styles.icon} src={pressedCursor} alt="" />
      )}
      {buttonText}
    </Button>
  );
};

BookDeliveriesButton.defaultProps = {
  asyncValidationFunc: undefined,
  beforeFn: undefined,
};

BookDeliveriesButton.propTypes = {
  deliveryIDs: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  asyncValidationFunc: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  creatingDeliveries: PropTypes.bool.isRequired,
  bookingMode: PropTypes.string.isRequired,
  beforeFn: PropTypes.func,
};

export default connect(state => ({
  creatingDeliveries: creatingDeliveriesSelector(state),
}))(BookDeliveriesButton);
